import { Action, Dispatch } from "redux";
import api from "../../api";
export interface AddAnydayQRCodeAction extends Action {
    type: "ADD_ANYDAY_QR_CODE";
    anydayQRCode: AnydayQRCode;
    departmentId: string;
}
export interface GetAnydayQRCodesAction extends Action {
    type: "GET_ANYDAY_QR_CODES";
    anydayQRCodes: AnydayQRCode[];
    departmentId: string;
}

export interface DeleteAnydayQRCodeAction extends Action {
    type: "DELETE_ANYDAY_QR_CODE";
    id: string;
    departmentId: string;
}

export const getAnydayQRCodes = (departmentId: string) =>async (dispatch: Dispatch) => {
    const result = await api.AnydayApi.get(departmentId);
       console.log("ADD_ANYDAY_QR_CODE",result)
    dispatch({
        type: "GET_ANYDAY_QR_CODES",
        anydayQRCodes: result,
        departmentId: departmentId
    } as GetAnydayQRCodesAction);
};

export const upsetAnydayQRCode = (anydayQRCode: AnydayQRCode) =>async (dispatch: Dispatch) => {
    
    const result = await api.AnydayApi.upset(anydayQRCode); 
    dispatch({
        type: "ADD_ANYDAY_QR_CODE",
        anydayQRCode: result,
        departmentId: anydayQRCode.departmentId
    } as AddAnydayQRCodeAction);
};
export const deleteAnydayQRCode = (id: string, departmentId: string) =>async (dispatch: Dispatch) => {
    await api.AnydayApi.delete(id); 
    dispatch({
        type: "DELETE_ANYDAY_QR_CODE",
        id: id,
        departmentId: departmentId
    } as DeleteAnydayQRCodeAction);
};